import { WebPlugin } from '@capacitor/core';
export class CapacitorTapJackingWeb extends WebPlugin {
    async preventOverlays() {
        return Promise.resolve();
    }
    async enableOverlays() {
        return Promise.resolve();
    }
}
//# sourceMappingURL=web.js.map